import styled from "styled-components";
import CompanyHeadImg from "@public/assets/main/ceo.png"
import {SIZES} from "@/components/constants";
const CompanyHeadSection = ({data}) => {
    return(
        <SectionWrap>
            <div className={"container"}>
                <img src={CompanyHeadImg?.src} alt={"CEO 이미지"} />
                <div className={"text-box"}>
                    <h2 className={"box-title"} dangerouslySetInnerHTML={{__html: data["ceo-pr-subject"]}}/>
                    <div className={"box-description"} dangerouslySetInnerHTML={{__html: data["ceo-pr-message"]}}/>
                    <p className={"name"} dangerouslySetInnerHTML={{__html: data["ceo-name"]}}/>
                </div>
            </div>
        </SectionWrap>
    )
}
const SectionWrap = styled.section`
    padding: 40px 0 60px;
    background-color: #fff;
    .container{
        width: 100%;
        margin: 0 auto;
        padding: 0 24px;
        display: flex;
        flex-direction: column;
        gap: 40px;
        .text-box{
            display: flex;
            flex-direction: column;
            gap: 24px;
            .box-title{
                font-size: 18px;
                line-height: 64px;
                font-weight: 700;
            }
            .box-description{
                display: flex;
                flex-direction: column;
                gap: 8px;
                p{
                    font-size: 12px;
                    line-height: 16px;
                    color: rgba(95, 93, 106, 0.5);
                }
                .info{
                    line-height: 28px;
                    font-size: 18px;
                    font-family: "Marcellus SC", serif !important;
                    font-weight: 400;
                    > *{
                        font-family: "Marcellus SC", serif !important;
                        font-weight: 400;
                    }
                    .green{
                        color: #07903a;
                    }
                }
            }
            .name{
                font-size: 12px;
                line-height: 16px;
                font-weight: 700;
                color: #07903a;
            }
            .black{
                color: #5f5d67;
                font-weight: 700;
            }
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        .container{
            .text-box{
                .box-title{
                    line-height: 28px;
                }
            }
        }
    }
    @media (min-width: ${SIZES.MOBILE}) {
        .container {
            max-width: 640px;
            .text-box{
                .box-description{
                    p{
                        font-size: 14px;
                        line-height: 20px;
                    }
                }
                .name{
                    font-size: 14px;
                    line-height: 20px;
                }
            }
        }
    }
    @media (min-width: ${SIZES.MOBILE_L}) {
        .container {
            max-width: 768px;
            flex-direction: row;
            align-items: center;
            gap: 56px;
            img{
                max-width: 320px;
            }
            .text-box{
                .box-description{
                    p{
                        font-size: 16px;
                        line-height: 24px;   
                    }
                    .info{
                        font-size: 31px;
                    }
                }
                .name{
                    font-size: 16px;
                    line-height: 24px;
                }
            }
        }
    }
    @media (min-width: ${SIZES.TABLET}) {
        padding: 80px 0 120px;
        .container{
            max-width: 1024px;
            gap: 80px;
            padding: 0 40px;
            img{
                max-width: 380px;
            }
            .text-box{
                .box-title{
                    font-size: 40px;
                }
                .box-description{
                    p{
                        font-size: 18px;
                        line-height: 28px;
                    }
                }
                .name{
                    font-size: 18px;
                    line-height: 28px;
                }
            }
        }
    }
    @media (min-width: ${SIZES.TABLET_L}) {
        .container {
            max-width: 1280px;
            img{
                max-width: 500px;
            }
        }
    }
    @media screen and (min-width: ${SIZES.PC}) {
        .container {
            max-width: 1536px;
        }
    }
`
export default CompanyHeadSection;